// var isIE11 = !!window.MSInputMethodContext && !!document.documentMode
//
// // Polyfill to address Typeform integration issue
// isIE11 && require("/static/polyfills/element-append.js")
//
// // Polyfill to address AWS Crypto Issue
// isIE11 && require("/static/polyfills/uint32array-from.js")
//
// // Bootstrap Polyfill for IE11
// /* jshint ignore:start*/
// isIE11 && require("/static/polyfills/bootstrap-ie11.min.css")
// isIE11 && require("/static/polyfills/element-qsa-scope@1.js")
// isIE11 && require("/static/polyfills/polyfill.min.js")
// isIE11 && require("/static/polyfills/ie11CustomProperties.min.js")
// /* jshint ignore:end*/
//
// // Custom overide for IE11
// isIE11 && require("/static/polyfills/IE11-custom-override.css")
import React from 'react';

import '@dsl/loop-next-fonts';
import '@dsl/loop-next-react/dist/index.css';
import '@popperjs/core/dist/umd/popper.min';
import 'bootstrap/dist/js/bootstrap.min';

import './src/styles/main.scss';
import { AccessibilityProvider } from './src/utils/AccessibilityContext';

export const wrapRootElement = ({ element }) => (
  <AccessibilityProvider>{element}</AccessibilityProvider>
);
